import React from 'react';
import { Accordion } from '../common';
import ResultsTable from '../ResultsTable';
import ResultsAccordionProps, { Accordion as AccordionType, Content as ContentType, Event } from './type';
import './styles.scss';

interface ContentProps {
  eventCode: string;
  disciplineCode: string;
  raceType: string;
  title: string;
  raceName?: string;
  onBeforeLoad?: () => {};
  onLoad?: () => {};
}

const Content = ({
  eventCode,
  disciplineCode,
  raceType,
  title,
  raceName,
  onBeforeLoad,
  onLoad,
}: ContentProps) => (
  <div className="results-accordion__content">
    <ResultsTable
      title={title}
      asyncRequest={{
        eventCode,
        raceType,
        raceName,
        disciplineCode,
        // @ts-ignore
        onLoad: onLoad || (() => {}),
        onBeforeLoad,
      }}
    />
  </div>
);
const ResultsAccordion = ({
  accordion,
  discipline,
  disciplineCode,
}: ResultsAccordionProps) => {
  const toContentPanel = (event: Event) => ({
    label: <span className="results-accordion__trigger">{event.title}</span>,
    content: (
      <Content
        eventCode={event.eventCode}
        disciplineCode={disciplineCode}
        raceType={event.raceType}
        raceName={event.title}
        title={event.title}
      />
    ),
    isAsync: true,
  });

  const toNestedPanel = (nested: AccordionType | ContentType) => {
    const { results } = nested as ContentType;
    if (results && results.length === 1) {
      const event = results[0];
      return {
        label: <span className="results-accordion__trigger">{nested.label}</span>,
        content: (
          <Content
            eventCode={event.eventCode}
            raceType={event.raceType}
            raceName={nested.label}
            disciplineCode={disciplineCode}
            title={event.title}
          />
        ),
        isAsync: true,
      };
    }
    return {
      label: <span className="results-accordion__trigger">{nested.label}</span>,
      content: (nested as AccordionType).accordion
        ? <Accordion panels={(nested as AccordionType).accordion.map(toNestedPanel)} themeColor="white" discipline={discipline} />
        : <Accordion panels={(nested as ContentType).results.map(toContentPanel)} themeColor="white" discipline={discipline} />,
    };
  };
  return (
    <div className="results-accordion">
      <div className="results-accordion__container">
        <Accordion panels={accordion.map(toNestedPanel)} themeColor="white" discipline={discipline} isResults />
      </div>
    </div>
  );
};
export default ResultsAccordion;
